console.log('Easy payment');

// Function to get the variant ID from the URL
function getVariantFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('variant');
}

// Detect changes to the variant parameter in the URL
setInterval(() => {
  const currentVariant = getVariantFromURL();
  // const selector = document.querySelector('quantity-selector');
  if (currentVariant !== window.previousVariantId) {
    window.previousVariantId = currentVariant;
    updatePaymentOptionAmounts();
  }
}, 1000);

function getAmountForCurrentVariant(currentVariantId) {
  const variantIdRefElement = document.querySelector(
    `span[data-variantidref="${currentVariantId}"]`
  );
  if (variantIdRefElement) {
    const rawAmount = Number(variantIdRefElement.innerHTML)
    const updatedAmount = (rawAmount / 4 / 100).toFixed(2)
    return `$${updatedAmount}`;
  } else {
    console.log('variantIdRefElement not found');
    return null;
  }
}

function updatePaymentOptionAmounts() {
  const selectedVariantId = getVariantFromURL();
  console.log('HH selectedVariantId ', selectedVariantId);

  if (selectedVariantId) {
    const dataVariantId = document.querySelector('[data-variantid]');
    console.log('HH selectedVariantId ', selectedVariantId);

    dataVariantId.setAttribute('data-variantid', selectedVariantId);

    const paymentOptions = document.querySelector('.instant-finance-new');
    const humm = paymentOptions.querySelector(
      '.payment-option[data-option="humm"]'
    );
    const afterpay = paymentOptions.querySelector(
      '.payment-option[data-option="afterpay"]'
    );
    const zippay = paymentOptions.querySelector(
      '.payment-option[data-option="zippay"]'
    );

    if (zippay) {
      console.log('HH zippay ', zippay);
      const amount = zippay.querySelector('.f_money');
      console.log('HH zippay amount ', amount);
      const newAmount = getAmountForCurrentVariant(selectedVariantId);
      if(newAmount) {
        amount.innerHTML = newAmount;
      }
    }

    if (afterpay) {
      console.log('HH afterpay ', afterpay);
      const amount = afterpay.querySelector('.f_money');
      console.log('HH afterpay amount ', amount);
      const newAmount = getAmountForCurrentVariant(selectedVariantId);
      if(newAmount) {
        amount.innerHTML = newAmount;
      }
    }

    if (humm) {
      console.log('HH humm ', humm);
      const amount = humm.querySelector('.f_money');
      console.log('HH humm amount ', amount);
      const newAmount = getAmountForCurrentVariant(selectedVariantId);
      if(newAmount) {
        amount.innerHTML = newAmount;
      }
    }

    if (zippay) {
      console.log('HH zippay ', zippay);
      const amount = zippay.querySelector('.f_money');
      console.log('HH zippay amount ', amount);
      const newAmount = getAmountForCurrentVariant(selectedVariantId);
      if(newAmount) {
        amount.innerHTML = newAmount;
      }
    }
  }
}